import { computed } from 'vue';

// TODO: modificado por Ublux
function resolveInbox(inbox) {
  const details = inbox.value || inbox;
  return {
    channel_type: details.channel_type || details.channelType,
    provider: details.provider,
    medium: details.medium,
  };
}

const channelColorMap = {
  'Channel::Whatsapp': { bg: 'rgba(37, 211, 102, 0.15)', text: '#25D366' },
  'Channel::TwilioSms': { bg: 'rgba(37, 211, 102, 0.15)', text: '#25D366' },
  'Channel::Api': { bg: 'rgba(37, 211, 102, 0.15)', text: '#25D366' },
  'Channel::Instagram': {
    bg: 'linear-gradient(135deg, rgba(131, 58, 180, 0.15), rgba(228, 64, 95, 0.15), rgba(252, 175, 69, 0.15))',
    text: 'linear-gradient(135deg, #833AB4, #E4405F, #FCAF45)',
    gradient: true,
  },
  'Channel::FacebookPage': { bg: 'rgba(0, 132, 255, 0.15)', text: '#0084FF' },
  'Channel::Telegram': { bg: 'rgba(0, 136, 204, 0.15)', text: '#0088cc' },
  'Channel::TwitterProfile': { bg: 'rgba(0, 0, 0, 0.1)', text: '#14171A' },
  'Channel::Line': { bg: 'rgba(0, 185, 0, 0.15)', text: '#00B900' },
  'Channel::Email': { bg: 'rgba(100, 121, 143, 0.15)', text: '#64798F' },
  'Channel::Sms': { bg: 'rgba(100, 121, 143, 0.15)', text: '#64798F' },
  'Channel::Tiktok': { bg: 'rgba(255, 0, 80, 0.15)', text: '#ff0050' },
  'Channel::WebWidget': { bg: 'rgba(59, 130, 246, 0.15)', text: '#3B82F6' },
  'Channel::Voice': { bg: 'rgba(124, 58, 237, 0.15)', text: '#7C3AED' },
};

const providerColorMap = {
  google: { bg: 'rgba(234, 67, 53, 0.15)', text: '#EA4335' },
  microsoft: { bg: 'rgba(0, 120, 212, 0.15)', text: '#0078D4' },
};

export function useChannelColor(inbox) {
  const fallback = { bg: 'rgba(0, 0, 0, 0.06)', text: 'currentColor' };

  return computed(() => {
    const { channel_type: type, provider, medium } = resolveInbox(inbox);

    if (type === 'Channel::Email' && provider) {
      const providerColor = providerColorMap[provider];
      if (providerColor) return providerColor;
    }

    if (type === 'Channel::TwilioSms' && medium === 'whatsapp') {
      return channelColorMap['Channel::Whatsapp'];
    }

    return channelColorMap[type] ?? fallback;
  });
}

export function useChannelIcon(inbox) {
  const channelTypeIconMap = {
    'Channel::Api': 'i-woot-whatsapp',
    'Channel::Email': 'i-woot-mail',
    'Channel::FacebookPage': 'i-woot-messenger',
    'Channel::Line': 'i-woot-line',
    'Channel::Sms': 'i-woot-sms',
    'Channel::Telegram': 'i-woot-telegram',
    'Channel::TwilioSms': 'i-woot-sms',
    'Channel::TwitterProfile': 'i-ri-twitter-x-fill',
    'Channel::WebWidget': 'i-woot-website',
    'Channel::Whatsapp': 'i-woot-whatsapp',
    'Channel::Instagram': 'i-woot-instagram',
    'Channel::Tiktok': 'i-woot-tiktok',
    'Channel::Voice': 'i-ri-phone-fill',
  };

  const providerIconMap = {
    microsoft: 'i-woot-outlook',
    google: 'i-woot-gmail',
  };

  const channelIcon = computed(() => {
    const { channel_type: type, provider, medium } = resolveInbox(inbox);
    let icon = channelTypeIconMap[type];

    if (type === 'Channel::Email' && provider) {
      if (Object.keys(providerIconMap).includes(provider)) {
        icon = providerIconMap[provider];
      }
    }

    if (type === 'Channel::TwilioSms' && medium === 'whatsapp') {
      icon = 'i-woot-whatsapp';
    }

    return icon ?? 'i-ri-global-fill';
  });

  return channelIcon;
}
